import { Grid, Paper } from "@mui/material";
import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";

import AuthPageLayout from "../layout/AuthPageLayout";
import LoadingIndicator from "../components/common/LoadingSpinner";
import { useUserAPI } from "../context/userAPIContext";
import { CustomToolbar } from "../components/common/CustomDataGridToolBar";
import { CustomModal } from "../components/common/CustomModal";
import { ADMIN_ROLE } from "../utils/constants";
import { getUsers, postUser } from "../services/api/users";

const createUserModalProps = { 
  title: 'Create Skill',
  description:
    'Backend response to create skill:',
  confirmButtonText: 'Create',
  cancelButtonText: 'Cancel',
  confirmButtonColor: 'primary',
  variant: 'outlined',
};

export const Users = () => {

  const usersTableColumns = [
    {
      field: 'name',
      headerName: 'NAME',
      minWidth: 150,
      flex: 1,
      headerClassName: 'header-style',
      headerAlign: 'center'
    },
    {
      field: 'lastname',
      headerName: 'LAST NAME',
      minWidth: 150,
      flex: 1,
      headerClassName: 'header-style',
      headerAlign: 'center'
    }
  ];

  const isAdmin = () => user.roles.demo && user.roles.demo.includes(ADMIN_ROLE);

  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const { user, checkUserAuthentication } = useUserAPI();
  const [ messageCreate, setMessageCreate] = useState('');

  const createUser = async () => {
    setOpenCreateModal(true)
    const message = await postUser();
    setMessageCreate(message);
  };

  useEffect(() => {
    checkUserAuthentication();
    const fetchUsers = async () => {
      setIsLoading(true);
      const fetchedUsers = await getUsers();
      setUsers(fetchedUsers);
      setIsLoading(false);
    };

    fetchUsers();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <AuthPageLayout containerWidth='lg'>
        <Grid container direction="column">
            <Paper
              sx={{
                p: 5,
                display: "flex",
                flexDirection: "column",
                height: "100%",
                width: "100%",
              }}
            >
              <Typography variant="h6" sx={{paddingBottom:1, fontWeight:"bold"}}>
                Users
              </Typography>
              {
                isLoading ?
                (<LoadingIndicator />) :
                (
                  <div style={{ height: 390, width: '100%' }}>
                    <div style={{ display: 'flex', height: '100%' }}>
                      <div style={{ flexGrow: 1 }}>
                        <DataGrid
                          {...(isAdmin() ? {components: { Toolbar: () => <CustomToolbar addAction={createUser}/> }}: {})}
                          sx={{ fontSize: 16, '& .header-style': {
                            fontSize: 18,
                          },}}
                          rows={users}
                          columns={usersTableColumns}
                          getRowId={(user) => user.id}
                          pageSize={10}
                          rowsPerPageOptions={[5]}
                          disableSelectionOnClick
                          disableColumnResize={false}
                          checkboxSelection={false}
                          autoPageSize={true}
                          getRowHeight={() => 'auto'}
                        />
                      </div>
                    </div>
                  </div>
                )
              }
            </Paper>
          </Grid>
          <CustomModal
          {...createUserModalProps}
          open={openCreateModal}
          handleClose={() => setOpenCreateModal(false)}
          handleConfirm={() => setOpenCreateModal(false)}
          handleCancel={() => setOpenCreateModal(false)}
          children={<h1>{messageCreate}</h1>}
        />
      </AuthPageLayout>
    </>
  )
};
